import { Control, FieldPath, FieldValues } from "react-hook-form";
import { useTranslation } from "react-i18next";

import GaiaSliderElement from "~/modules/app/components/GaiaSliderElement";
import SliderTextInput from "~/modules/app/components/GaiaSliderElement/SliderTextInput";

type Props<T extends FieldValues> = {
    control: Control<T>;
    name: FieldPath<T>;
    disabled?: boolean;
};

export default function WindForceSlider<T extends FieldValues>({ control, name, disabled }: Props<T>) {
    const { t } = useTranslation("protocol");

    return (
        <GaiaSliderElement
            control={control}
            name={name}
            label={t("protocolVisitsWeatherEditor.labelMaxWindForce")}
            min={0}
            max={10}
            step={1}
            valueLabelFormat={value => `${value} Bft`}
            disabled={disabled}
            inputElement={({ min, max, step }) => (
                <SliderTextInput
                    control={control}
                    name={name}
                    disabled={disabled}
                    suffix="Bft"
                    min={min}
                    max={max}
                    step={step}
                />
            )}
        />
    );
}
